module.exports = __webpack_public_path__ + "static/media/ankring.a8e7c24f.png";